import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Box } from "@mui/material";
import Divider, { dividerClasses } from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import { ModalNames, Recipe, State, StateProps } from "./state";

export interface MealSelctionOptions extends StateProps {}

export default function MealSelction(options: MealSelctionOptions) {
  return (
    <>
      <Accordion
        defaultExpanded={options.state.settings?.mealSelectionExpanded ?? false}
      >
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon />}
          aria-controls="mealSelection-content"
          id="mealSelection-header"
        >
          <Typography component="span">Meals</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 1,
              bgcolor: "background.paper",
              margin: "auto",
              justifyContent: "center",
              color: "text.secondary",
              "& svg": {
                m: 1,
              },
              [`& .${dividerClasses.root}`]: {
                mx: 0.5,
              },
            }}
          >
            <List
              sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
            >
              {Object.values(options.state.menu)
                .sort((a, b) => {
                  return a.mealOrder - b.mealOrder;
                })
                .sort((a, b) => {
                  return ((new Date(a.date) as any) -
                    (new Date(b.date) as any)) as number;
                })
                .map((menuItem, i) => {
                  const d = new Date(menuItem.date);
                  const dayName = d.toLocaleDateString("en-US", {
                    weekday: "long",
                  });
                  return menuItem.recipe?.name ? (
                    <>
                      <ListItem
                        onClick={() =>
                          openMealCard({
                            ...options,
                            selectedRecipe: menuItem.recipe,
                          })
                        }
                        alignItems="flex-start"
                      >
                        <ListItemAvatar>
                          <Avatar alt={dayName} src={`${dayName}.jpg`} />
                        </ListItemAvatar>
                        <ListItemText
                          primary={`${
                            menuItem.mealName
                          } ${dayName} ${d.toLocaleDateString("en-US")}`}
                          secondary={
                            <React.Fragment>
                              <Typography
                                component="span"
                                variant="body2"
                                sx={{
                                  color: "text.primary",
                                  display: "inline",
                                }}
                              >
                                {menuItem.recipe?.name}{" "}
                              </Typography>
                            </React.Fragment>
                          }
                        />
                      </ListItem>
                      {i === Object.values(options.state.menu).length - 1 ? (
                        <></>
                      ) : (
                        <Divider variant="inset" component="li" />
                      )}
                    </>
                  ) : (
                    <></>
                  );
                })}
            </List>
          </Box>
        </AccordionDetails>
      </Accordion>
    </>
  );
}

export interface OpenMealCardProps extends StateProps {
  readonly selectedRecipe?: Recipe;
}
export function openMealCard(props: OpenMealCardProps) {
  props.setState((prevState: State) => {
    return {
      ...prevState,
      openModals: {
        ...prevState.openModals,
        [ModalNames.RECIPE_CARD]: true,
      },
      selectedRecipe: props.selectedRecipe,
    };
  });
}
